const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[1-9]\d{6,14}$/;
const CBU_REGEX = /^\d{22}$/;
const DNI_REGEX = /^\d{7,8}$/;
const CARD_NUMBER_REGEX = /^\d{16}$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim());
}

export function sanitizeNoSpaces(value: string): string {
  return value.replace(/\s/g, '');
}

export function isValidPhone(phone: string): boolean {
  const cleaned = phone.replace(/[\s\-()]/g, '');
  return PHONE_REGEX.test(cleaned);
}

export function isValidCBU(cbu: string): boolean {
  if (!CBU_REGEX.test(cbu)) return false;

  // Validación de dígitos verificadores
  const validateBlock1 = (block: string): boolean => {
    const multipliers = [7, 1, 3, 9, 7, 1, 3];
    const sum = block
      .slice(0, 7)
      .split('')
      .reduce((acc, digit, idx) => acc + parseInt(digit) * multipliers[idx]!, 0);
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(block[7]!);
  };

  const validateBlock2 = (block: string): boolean => {
    const multipliers = [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3];
    const sum = block
      .slice(0, 13)
      .split('')
      .reduce((acc, digit, idx) => acc + parseInt(digit) * multipliers[idx]!, 0);
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(block[13]!);
  };

  return validateBlock1(cbu.slice(0, 8)) && validateBlock2(cbu.slice(8));
}

export function isValidDNI(dni: string): boolean {
  return DNI_REGEX.test(dni);
}

export function isValidCardNumber(cardNumber: string): boolean {
  // Remover espacios y guiones para validar
  const cleaned = cardNumber.replace(/[\s\-]/g, '');
  return CARD_NUMBER_REGEX.test(cleaned);
}

export function sanitizeAlphanumeric(value: string): string {
  return value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]/g, '');
}
